// AUTO-GENERATED FILE - do not edit. Regenerated by scripts/generate-build-info.js.
export const BUILD_INFO = {
  gitSha: '7792e1ce7b0ab8fb71235fbe1409de41a65d7ef1',
  gitShaShort: '7792e1ce',
  gitBranch: 'refs/tags/release-2.6.10.2.1',
  gitTag: 'release-2.6.10.2.1',
  buildTime: '2026-10-15T16:02:23.167Z',
} as const;
